import StudentRelationshipIcon from '@material-ui/icons/ViewList';

import StudentRelationshipList from './StudentRelationshipList';

export default {
    list: StudentRelationshipList,
    icon: StudentRelationshipIcon,
};
